import * as React from 'react';

import {GreySection} from 'shells/layout/grey-section';
import {LinkWithCopyButton} from 'shells/link/link-with-copy-button';
import type {SelectMenuOption} from 'shells/select-menu/select-menu';
import {ThumbnailButtonCard} from 'shells/thumbnail/thumbnail-button-card/thumbnail-button-card';
import {RelativeTimestamp} from 'shells/timestamp/relative-timestamp';

export const THUMBNAIL_HEIGHT = 196;

export type Props = {
    name: string;
    nutshellPublishedUrl: string;
    customPublishedUrl: string | null | undefined;
    lastModifiedTime: number;
    thumbnailUrl: string | null | undefined;
    onClick: () => void;
    options?: SelectMenuOption[];
    getActionMenuRef?: (arg1?: HTMLElement | null | undefined) => void;
    isSelected?: boolean;
    backgroundColor: string;
};

export function PageThumbnailButtonCard(props: Props) {
    return (
        <ThumbnailButtonCard
            title={props.name}
            secondaryInfo={
                <LinkWithCopyButton
                    link={props.customPublishedUrl || props.nutshellPublishedUrl}
                    size='small'
                />
            }
            tertiaryInfo={
                <div className='flex'>
                    <div className='mr-4'>Last updated</div>
                    <RelativeTimestamp datetime={props.lastModifiedTime} />
                </div>
            }
            thumbnail={
                props.thumbnailUrl || (
                    <GreySection content={null} noMargin={true} isFullHeight={true} />
                )
            }
            thumbnailHeight={THUMBNAIL_HEIGHT}
            onClick={props.onClick}
            options={props.options}
            getActionMenuRef={props.getActionMenuRef}
            isSelected={props.isSelected}
            backgroundColor={props.backgroundColor}
        />
    );
}
